import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getVehiculoPorPatente } from '../../helpers/api_helper';

const useObtenerVehiculoPorPatente = (patente) => {
    const [vehiculo, setVehiculo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);

    useEffect(() => {
        const fetchVehiculo = async () => {
            console.log('Fetching vehiculo for patente:', patente);
            if (!patente || !tenantId || !empresa) return;
            console.log('Fetching with tenantId:', tenantId, 'empresa:', empresa, 'patente:', patente);
            setLoading(true);
            setError(null);
            try {
                const response = await getVehiculoPorPatente({
                    tenantId,
                    empresa,
                    patente
                });
                console.log('Response from API for vehiculo by ID:', response);
                if (response.PATENT) {
                    setVehiculo(response);
                } else {
                    throw new Error('No se encontró el vehículo solicitado');
                }
            } catch (err) {
                const errorMessage = `Failed to fetch vehiculo: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setVehiculo(null);
            } finally {
                setLoading(false);
            }
        };

        fetchVehiculo();
    }, [tenantId, empresa, departamento, patente]);

    return { vehiculo, loading, error };
};

export default useObtenerVehiculoPorPatente;